import { render, staticRenderFns } from "./ForgotPasswordView.vue?vue&type=template&id=4a431f9a&scoped=true&"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPasswordView.vue?vue&type=style&index=0&id=4a431f9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a431f9a",
  null
  
)

export default component.exports